module.exports = __webpack_public_path__ + "src/assets/img/page8/fcf91b34fb490fe7dad490e6e300bc71.png";